import { combineReducers } from 'redux'
import game from './game'

export default combineReducers({
  game
})
